module.exports = __webpack_public_path__ + "static/media/pic_dni@2x.3ff46527.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/pic_dni@2x.jpg
// module id = 361
// module chunks = 0